export default {
	title: "Centre Personnel",
	subTitle: ["Profil", "Sécurité", "Système"],
	menu: [
		"Modifier les Informations Personnelles",
		"Nom d'utilisateur",
		"Mettre à jour le mot de passe",
		"Mettre à jour le mot de passe de la transaction"
	],
	updatePassword: {
		form: {
			label: ["Ancien mot de passe", "Nouveau mot de passe", "Confirmer le nouveau mot de passe"]
		}
	},
	updateTransactionPassword: {
		form: {
			label: ["Ancien mot de passe", "Nouveau mot de passe", "Confirmer le nouveau mot de passe"]
		}
	}
};
